import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    notifications: [],
    readedNotifications: [],
    unreadedNotifications: [],
};

export default createReducer(initial, {
    [actions.setNotifications]: (state, action) => {
        return { ...state, notifications: action.payload };
    },
    [actions.setReadedNotifications]: (state, action) => {
        return { ...state, readedNotifications: action.payload };
    },
    [actions.setUnreadedNotifications]: (state, action) => {
        return { ...state, unreadedNotifications: action.payload };
    },
});
